import { Box, Paper, Typography } from '@mui/material'
import React, { useCallback } from 'react'
import { allNodesOfType } from '../utility/TreeHelpers'
import { StartAndMonitorFlow } from '../contentService/FlowStartandMonitor'
import { useGetTreeById } from '../../reducers/trees_hooks'
import { processWeightedSkillsListsFlow } from '../standards/utility'
import styled from '@emotion/styled'

const SectionPaper = styled(Paper)(() => ({
  padding: '24px',
  marginBottom: '24px',
}))

interface WeightedSkillsListsProps {
  treeId: string
  treeVer: string
}

export function WeightedSkillsLists({
  treeId,
  treeVer,
}: WeightedSkillsListsProps) {
  const { tree, resetTree } = useGetTreeById({ treeId, versionId: treeVer })

  const handleFlowComplete = useCallback(() => {
    // Flow completed successfully - trigger tree refresh
    if (resetTree) {
      resetTree()
    }
  }, [resetTree])

  const startFlowFunction = useCallback(async () => {
    if (!tree) {
      throw new Error('Tree not loaded')
    }

    const weightedSkillsListNodes = allNodesOfType(tree, 'weighted_skills_list')
    return processWeightedSkillsListsFlow({
      tree_id: tree.tree_id,
      version_id: tree.version,
      weighted_skills_list_nodes: weightedSkillsListNodes.map(
        (node) => node.id,
      ),
    })
  }, [tree])

  if (!tree) {
    return <Box>Loading tree...</Box>
  }

  const skillsListNodes = allNodesOfType(tree, 'skills_list')
  const weightedSkillsListNodes = allNodesOfType(tree, 'weighted_skills_list')

  if (weightedSkillsListNodes.length === 0) {
    return null
  }

  return (
    <SectionPaper>
      <Typography variant="h6" gutterBottom>
        Weighted Skills Lists
      </Typography>
      <Box mb={1}>Skills lists found: {skillsListNodes.length}</Box>
      <Box mb={1}>
        Weighted skills lists found: {weightedSkillsListNodes.length}
      </Box>

      <StartAndMonitorFlow
        disabled={false}
        buttonText="Correct Weighted Skills Lists"
        processingText="Correcting weighted skills lists..."
        onFlowComplete={handleFlowComplete}
        startFlowFunction={startFlowFunction}
      />
    </SectionPaper>
  )
}
